export default {
  footer: {
    description: 'સેક્યુવિઝ વિઝિટર મેનેજમેન્ટ સિસ્ટમ, રિયાના ગ્રુપની પેટાકંપની'
  }
};
